import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FontIcon from 'components/FontIcon';
import BuildChildren from 'utils/BuildChildren';
import classes from './CardIconF.module.scss';

const CardIconF = (props) => {
  const {
    heading,
    contentMarkup,
    buttons = [],
    color,
    icon,
    link,
  } = props;

  const borderColor = `border-${color}`;

  let iconHtml = '';

  if (icon) {
    if (link && link.href) {
      iconHtml = (
        <a
          aria-label={heading}
          href={link.href}
          target={link.target}
        >
          <FontIcon icon={icon} className={classes.icon} />
        </a>
      );
    } else {
      iconHtml = <FontIcon icon={icon} className={classes.iconNoLink} />;
    }
  }

  return (
    <div className={classNames(classes.container, borderColor)}>
      <div className={classes.wrapper}>
        <div>
          {iconHtml}
        </div>
        {heading &&
          <h3
            className={classes.heading}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
        {buttons.length > 0 &&
          <div className={classes.itemsContainer}>
            {buttons.map((item, i) => (
              <div className={classes.button} key={i}>
                {BuildChildren(item)}
              </div>
            ))}
          </div>}
      </div>
    </div>
  );
};

CardIconF.propTypes = {
  /**
   * Heading of the card
  */
  heading: PropTypes.string,
  /**
   * HTML content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * List of button objects to display in the card
  */
  buttons: PropTypes.array,
  /**
   * Border color of the card
  */
  color: PropTypes.string,
  /**
   * Icon of the card
  */
  icon: PropTypes.string,
  /**
   * Link where you get redirected when clicking on the card
  */
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
  }),
};

export default CardIconF;
